import React from 'react';
import PropTypes from 'prop-types';
import { isValid } from '../../../../utils';
import './sub-head.scss';

const MiniHed = ({ data, className, articleLayout, isSuperlative = false }) => {
  if (!isValid(data)) {
    return null;
  }
  const miniHedClass = (articleLayout === 'Standard') ? `${className} standard` : className;
  if (isSuperlative) {
  	 return (<h2 className={miniHedClass} dangerouslySetInnerHTML={ { __html: data } }></h2>);
  } else {
  	return (<h3 className={miniHedClass} dangerouslySetInnerHTML={ { __html: data } }></h3>);
  }
};

MiniHed.propTypes = {
  data: PropTypes.string,
  className: PropTypes.string,
};

export default MiniHed;
